import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import Block from "./Block";
import TrustBadgeBlockCollection from "./TrustBadgeBlockCollection";
var _attributes = /*#__PURE__*/new WeakMap();
export default class TrustBlock extends Block {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [TrustBlock.title_attribute_name]: null,
      [TrustBlock.paragraph_attribute_name]: null,
      [TrustBlock.badges_list_attribute_name]: TrustBadgeBlockCollection
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getTitleAttributeName() {
    return this.title_attribute_name;
  }
  static getParagraphAttributeName() {
    return this.paragraph_attribute_name;
  }
  static getBadgesListAttributeName() {
    return this.badges_list_attribute_name;
  }
  getTitle() {
    return this.getAttribute(TrustBlock.getTitleAttributeName());
  }
  getParagraph() {
    return this.getAttribute(TrustBlock.getParagraphAttributeName());
  }
  getBadges() {
    var _this$getAttribute;
    return (_this$getAttribute = this.getAttribute(TrustBlock.getBadgesListAttributeName())) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : [];
  }
}
_defineProperty(TrustBlock, "BLOCK_TITLE", 'components.trust_block.text');
_defineProperty(TrustBlock, "NAME", 'trust_block');
_defineProperty(TrustBlock, "title_attribute_name", 'title');
_defineProperty(TrustBlock, "paragraph_attribute_name", 'paragraph');
_defineProperty(TrustBlock, "badges_list_attribute_name", 'badges_list');